var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 3.9877C0.905 3.9877 0.5 4.3927 0.5 4.8877V16.5877C0.5 17.5777 1.31 18.3877 2.3 18.3877H14C14.495 18.3877 14.9 17.9827 14.9 17.4877C14.9 16.9927 14.495 16.5877 14 16.5877H3.2C2.705 16.5877 2.3 16.1827 2.3 15.6877V4.8877C2.3 4.3927 1.895 3.9877 1.4 3.9877ZM16.7 0.387695H5.9C4.91 0.387695 4.1 1.1977 4.1 2.1877V12.9877C4.1 13.9777 4.91 14.7877 5.9 14.7877H16.7C17.69 14.7877 18.5 13.9777 18.5 12.9877V2.1877C18.5 1.1977 17.69 0.387695 16.7 0.387695ZM9.5 11.6377V3.5377L14.423 7.2277C14.666 7.4077 14.666 7.76769 14.423 7.94769L9.5 11.6377Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.1d18999f07d4ae238cf634e4b71a3e72.svg";
export { ForwardRef as ReactComponent };